module.exports = __webpack_public_path__ + "dfc1e6512640b4bf1add1e8e7918557e.png";